'use client';

import { useInvitationLookup } from '@/src/shared/api/households';

/** The email an invitation is for; null while it loads, when it fails, or with no token. */
export function useInvitedEmail(token: string | null | undefined): string | null {
  const { data } = useInvitationLookup(token ?? null, false);
  return data?.invited_email ?? null;
}
